import * as ms from 'milliseconds';
import ImagestackIcon from '@shared/assets/icons/v2/imagestack.svg';
import { MBView } from '@shared/components/MBView';
import { Text } from '@shared/components/Text';
import { MBAnimationFadeIn } from '@shared/components/animation';
import { MBIcon } from '@shared/components/image';
import { Colors, SharedStyles } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { Styles } from './styles';

export function MBFileDropListenerOverlay() {
  return (
    <MBAnimationFadeIn duration={ms.seconds(0.2)} style={Styles.overlayContainer}>
      <MBView row center style={SharedStyles.absoluteCover}>
        <MBIcon noPadding color={Colors.v2.purple} source={ImagestackIcon} />
        <Text weight="bold">{i18n('form.dragAndDropToAttach')}</Text>
      </MBView>
      <MBView style={[SharedStyles.absoluteCover, Styles.overlayBorder]} />
    </MBAnimationFadeIn>
  );
}
